export default {
	issuer: "https://id.telenor.no",
	jwks_uri: "https://id.telenor.no/.well-known/openid-configuration/jwks",
	authorization_endpoint: "https://id.telenor.no/connect/authorize",
	token_endpoint: "https://id.telenor.no/connect/token",
	userinfo_endpoint: "https://id.telenor.no/connect/userinfo",
	end_session_endpoint: "https://id.telenor.no/connect/endsession",
	check_session_iframe: "https://id.telenor.no/connect/checksession",
	revocation_endpoint: "https://id.telenor.no/connect/revocation",
	introspection_endpoint: "https://id.telenor.no/connect/introspect",
	device_authorization_endpoint: "https://id.telenor.no/connect/deviceauthorization",
	backchannel_authentication_endpoint: "https://id.telenor.no/connect/ciba",
	pushed_authorization_request_endpoint: "https://id.telenor.no/connect/par",
	require_pushed_authorization_requests: false,
	frontchannel_logout_supported: true,
	frontchannel_logout_session_supported: true,
	backchannel_logout_supported: true,
	backchannel_logout_session_supported: true,
	scopes_supported: [
		"openid",
		"email",
		"phone",
		"tnn.legacy",
		"profile",
		"ial1",
		"ial2",
		"ial3",
		"ial0",
		"debug",
		"account.profiles",
		"externalidptoken",
		"tnn.ids",
		"tnn.profile.attributes",
		"extsub",
		"dealerid",
		"tweaccountid",
		"tenantid",
		"vipps",
		"offline_access",
	],
	claims_supported: [
		"sub",
		"email_verified",
		"email",
		"phone_number_verified",
		"phone_number",
		"legacy_roles",
		"legacy_status",
		"legacy_usertype",
		"legacy_username",
		"family_name",
		"kurtid",
		"birthdate",
		"middle_name",
		"given_name",
		"name",
		"analytics_uuid",
		"ial",
		"ibis.internal.external_issuer",
		"ibis.internal.external_sid",
		"ibis.internal.external_sub",
		"ibis.internal.external_idtoken",
		"account_profiles",
		"externalidptoken",
		"profiles",
		"tnuid",
		"attributes",
		"extsub",
		"dealer_id",
		"twe_account_id",
		"tenant_id",
	],
	grant_types_supported: [
		"authorization_code",
		"client_credentials",
		"refresh_token",
		"implicit",
		"urn:ietf:params:oauth:grant-type:device_code",
		"urn:openid:params:grant-type:ciba",
	],
	response_types_supported: [
		"code",
		"token",
		"id_token",
		"id_token token",
		"code id_token",
		"code token",
		"code id_token token",
	],
	response_modes_supported: ["form_post", "query", "fragment"],
	token_endpoint_auth_methods_supported: ["client_secret_basic", "client_secret_post"],
	id_token_signing_alg_values_supported: ["RS256"],
	subject_types_supported: ["public"],
	code_challenge_methods_supported: ["plain", "S256"],
	request_parameter_supported: true,
	request_object_signing_alg_values_supported: [
		"RS256",
		"RS384",
		"RS512",
		"PS256",
		"PS384",
		"PS512",
		"ES256",
		"ES384",
		"ES512",
		"HS256",
		"HS384",
		"HS512",
	],
	prompt_values_supported: ["none", "login", "consent", "select_account"],
	authorization_response_iss_parameter_supported: true,
	backchannel_token_delivery_modes_supported: ["poll"],
	backchannel_user_code_parameter_supported: true,
	dpop_signing_alg_values_supported: ["RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512"],
	self_service: "https://id.telenor.no/api/meta/v1/self-service",
	custom_logout_endpoint: "https://id.telenor.no/v1/logout",
	change_password_endpoint: "https://id.telenor.no/.well-known/change-password",
};
